// extracted by mini-css-extract-plugin
export default {"notFoundTestsBlock":"TestsNotFound_notFoundTestsBlock__UcfJU","text":"TestsNotFound_text__Xc9PE","notFoundTestsImg":"TestsNotFound_notFoundTestsImg__q2mOc"};